const menuConfig = [
  {
    id: 1,
    title: '探索',
    path: '/explore',
    icon: 'ExploreIcon',
    active: true,
    children: [
      { id: 101, title: "提案广场", path: "/explore/proposals", icon: "AppstoreOutlined", disableRename: true, disableDelete: true, defaultFilter: { exprs: [ { field: 'tags', op: 'EQ', values: ['ai_competition_model'] } ] } },
      { id: 102, title: "找队友", path: "/explore/friends", icon: "AppstoreOutlined", disableRename: true, disableDelete: true, defaultFilter: { exprs: [ { field: 'tags', op: 'EQ', values: ['找队友'] } ] } },
      { id: 103, title: "找点子", path: "/explore/ideas", icon: "AppstoreOutlined", disableRename: true, disableDelete: true, defaultFilter: { exprs: [ { field: 'tags', op: 'NOT_IN', values: ['找队友'] } ] } },
    ],
  },
  {
    id: 2,
    title: '提案',
    path: '/tasks',
    icon: 'TaskIcon',
  },
  {
    id: 4,
    title: '团队',
    path: '/workspace',
    icon: 'TeamOutlined',
    isWorkspace: true, // 标记这是一个工作台菜单，需要动态获取workspace ID
  },
  {
    id: 3,
    title: '资产',
    path: '/assets',
    icon: 'AppstoreOutlined',
  },

  // {
  //   id: 5,
  //   title: '文档',
  //   path: '/documents',
  //   icon: 'FileTextOutlined',
  // },
  // {
  //   id: 4,
  //   title: '场景',
  //   path: '/scenes',
  //   icon: 'AppstoreOutlined',
  // },
  // {
  //   id: 5,
  //   title: '卡片详情',
  //   path: '/cards/detail',
  //   icon: 'FileOutlined',
  // },
  // {
  //   id: 6,
  //   title: '个人中心',
  //   path: '/personal-info',
  //   icon: 'FileOutlined',
  // },
  // {
  //   id: 7,
  //   title: '工作台',
  //   path: '/workspace',
  //   icon: 'AppstoreOutlined',
  // },
];

export default menuConfig; 